import { FC, useEffect } from 'react';

import { Box, useMediaQuery } from '@mui/material';
import { IPersonalDiagnostic } from 'api/types';
import { useScrollToListElement, useSearchParam } from 'hooks';
import Timeline from 'portfolio3/components/common/Timeline';
import { PESONAL_DIAGNOSTIC_SEARCH_PARAM_KEY } from 'portfolio3/features/diagnostics/const';
import { commonTheme } from 'portfolio3/styles/theme';
import { mergeSx } from 'utils';

import PersonalDiagnosticCard from '../PersonalDiagnosticCard';
import * as styles from './styles';

interface IPersonalDiagnosticListProps {
  diagnostics: IPersonalDiagnostic[];
}

const PersonalDiagnosticList: FC<IPersonalDiagnosticListProps> = ({ diagnostics }) => {
  const isSmallScreen = useMediaQuery(commonTheme.breakpoints.down('commonSm'));

  const { searchParamValue: personalDiagnosticId, clearSearchParam } = useSearchParam(
    PESONAL_DIAGNOSTIC_SEARCH_PARAM_KEY,
  );

  const onScrolled = () => {
    clearSearchParam();
  };
  const { scrollToElement, registerElement } = useScrollToListElement({
    onScrolled,
  });

  useEffect(() => {
    if (!diagnostics.length || !personalDiagnosticId) {
      return;
    }

    const index = diagnostics.findIndex((diagnostic) => diagnostic.recordId === personalDiagnosticId);

    if (index === -1) {
      clearSearchParam();
      return;
    }

    scrollToElement(personalDiagnosticId);
  }, [personalDiagnosticId, diagnostics]);

  return (
    <Box className="personal-diagnostic-list">
      {diagnostics.map((diagnostic, index) => {
        const isFirstElement = index === 0;
        const year = new Date(diagnostic.eventDate).getFullYear();

        const rootStyles = mergeSx(
          !isFirstElement && styles.wrapperTopMargin,
          !isSmallScreen && styles.wrapperWithTimeline,
        );
        const timelineGapStyles = mergeSx(styles.timeline, { top: '-20px' });

        return (
          <Box key={diagnostic.recordId} sx={rootStyles} ref={registerElement(diagnostic.recordId)}>
            {!isSmallScreen && !isFirstElement && <Timeline sx={timelineGapStyles} />}
            {!isSmallScreen && (
              <Timeline withDot year={isFirstElement ? year : undefined} sx={styles.timeline} dotSx={{ top: '23px' }} />
            )}
            <PersonalDiagnosticCard diagnostic={diagnostic} />
          </Box>
        );
      })}
    </Box>
  );
};

export default PersonalDiagnosticList;
